import { Button } from "@altimateai/lego";
import { Popconfirm } from "@altimateai/lego";
import { useMutation } from '@tanstack/react-query';
import { deleteDatamate } from "@/helpers/apis";
import { useNavigate } from "react-router-dom";
import useTeammates from "../mcp/useTeammates";
import { toast } from "@altimateai/lego";
import { ReactNode } from "react";

interface DeleteTeammateProps {
  teammateId: string;
  onNavigateAfterDelete?: boolean;
  children?: ReactNode;
}

const DeleteTeammate = ({
  teammateId,
  onNavigateAfterDelete = false,
  children,
}: DeleteTeammateProps) => {
  const navigate = useNavigate();
  const { refetch } = useTeammates();

  const { mutate: deleteTeammate, isPending: isLoading } = useMutation({
    mutationFn: () => deleteDatamate(teammateId),
    onSuccess: async () => {
      toast({
        title: "Teammate deleted successfully",
      });
      await refetch();
      if (onNavigateAfterDelete) {
        navigate("/datamates");
      }
    },
    onError: (err: unknown) => {
      toast({
        title: `Error deleting teammate: ${(err as Error)?.message || err}`,
        variant: "destructive",
      });
    },
  });

  return (
    <Popconfirm
      title="Delete Teammate"
      description="Are you sure you want to delete this teammate? This action cannot be undone."
      onConfirm={() => deleteTeammate()}
    >
      {children || (
        <Button variant="destructive" disabled={isLoading}>
          Delete
        </Button>
      )}
    </Popconfirm>
  );
};

export default DeleteTeammate;
